(function () {
  'use strict';

  function titleCase(str) {
    return str.toLowerCase().replace(/(?:^|\s|-)\S/g, function (c) { return c.toUpperCase(); });
  }

  function PartFinder(sectionId) {
    var id = sectionId;
    var allBrands = null;
    var brandsLoading = false;
    var dynList = null;

    var applianceEl     = document.getElementById('pf-appliance-' + id);
    var brandWrapper    = document.getElementById('pf-brand-wrapper-' + id);
    var brandTrigger    = document.getElementById('pf-brand-trigger-' + id);
    var brandPanel      = document.getElementById('pf-brand-panel-' + id);
    var brandSearch     = document.getElementById('pf-brand-search-' + id);
    var brandDisplay    = document.getElementById('pf-brand-display-' + id);
    var brandValueInput = document.getElementById('pf-brand-value-' + id);
    var brandOptions    = document.querySelectorAll('#pf-brand-options-' + id + ' .part-finder__brand-option');
    var brandGroupLabel = document.getElementById('pf-brand-group-label-' + id);
    var brandEmpty      = document.getElementById('pf-brand-empty-' + id);
    var brandScroll     = brandPanel ? brandPanel.querySelector('.part-finder__brand-scroll') : null;
    var modelEl         = document.getElementById('pf-model-' + id);
    var searchBtn       = document.getElementById('pf-search-btn-' + id);

    if (!applianceEl || !brandTrigger || !searchBtn) return;

    /* Popular brands from static DOM */
    var popularBrands = [];
    brandOptions.forEach(function (opt) {
      popularBrands.push({ v: opt.dataset.value, l: opt.dataset.label });
    });

    /* ---- Panel open / close ---- */

    function openPanel() {
      brandTrigger.setAttribute('aria-expanded', 'true');
      brandPanel.removeAttribute('hidden');
      brandSearch.value = '';
      showPopularView();
      brandSearch.focus();
      fetchAllBrands();
    }

    function closePanel() {
      brandTrigger.setAttribute('aria-expanded', 'false');
      brandPanel.setAttribute('hidden', '');
    }

    brandTrigger.addEventListener('click', function () {
      brandTrigger.getAttribute('aria-expanded') === 'true' ? closePanel() : openPanel();
    });

    document.addEventListener('click', function (e) {
      if (brandWrapper && !brandWrapper.contains(e.target)) closePanel();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && brandTrigger.getAttribute('aria-expanded') === 'true') {
        closePanel();
        brandTrigger.focus();
      }
    });

    /* ---- Popular view (static DOM list) ---- */

    function showPopularView() {
      brandOptions.forEach(function (opt) { opt.removeAttribute('hidden'); });
      if (brandGroupLabel) brandGroupLabel.removeAttribute('hidden');
      if (brandEmpty) brandEmpty.setAttribute('hidden', '');
      if (dynList) dynList.setAttribute('hidden', '');
    }

    /* ---- Load all brands from static CDN asset ---- */

    function fetchAllBrands() {
      if (allBrands !== null || brandsLoading) return;
      brandsLoading = true;
      var brandsUrl = document.querySelector('[data-pf-brands-url]');
      if (!brandsUrl) { brandsLoading = false; return; }
      fetch(brandsUrl.dataset.pfBrandsUrl)
        .then(function (r) {
          if (!r.ok) throw new Error('status ' + r.status);
          return r.json();
        })
        .then(function (data) {
          allBrands = Array.isArray(data) && data.length > 0 ? data : null;
          brandsLoading = false;
          if (brandSearch.value.trim()) filterBrands(brandSearch.value.trim().toLowerCase());
        })
        .catch(function () {
          allBrands = null;
          brandsLoading = false;
        });
    }

    /* ---- Dynamic results container ---- */

    function getDynList() {
      if (!dynList) {
        dynList = document.createElement('ul');
        dynList.className = 'part-finder__brand-options';
        dynList.setAttribute('role', 'listbox');
        if (brandScroll) brandScroll.appendChild(dynList);
      }
      return dynList;
    }

    /* ---- Brand search input ---- */

    brandSearch.addEventListener('input', function () {
      var q = this.value.trim().toLowerCase();
      q ? filterBrands(q) : showPopularView();
    });

    function filterBrands(query) {
      /* Hide the popular static list */
      brandOptions.forEach(function (opt) { opt.setAttribute('hidden', ''); });
      if (brandGroupLabel) brandGroupLabel.setAttribute('hidden', '');

      /* Use full brand list if loaded, otherwise fall back to popular brands */
      var source = (allBrands !== null) ? allBrands : popularBrands.map(function (b) { return { l: b.l, v: b.v }; });

      var matches = source.filter(function (b) {
        return b.l.toLowerCase().indexOf(query) !== -1;
      });

      var list = getDynList();
      list.innerHTML = '';
      list.removeAttribute('hidden');

      if (matches.length === 0) {
        if (brandEmpty) brandEmpty.removeAttribute('hidden');
        list.setAttribute('hidden', '');
        return;
      }

      if (brandEmpty) brandEmpty.setAttribute('hidden', '');

      /* Render up to 60 matches */
      matches.slice(0, 60).forEach(function (brand) {
        var displayLabel = titleCase(brand.l);
        var li = document.createElement('li');
        li.className = 'part-finder__brand-option';
        li.setAttribute('role', 'option');
        li.dataset.value = brand.v;
        li.dataset.label = displayLabel;
        li.textContent = displayLabel;
        if (brandValueInput.value === brand.v) {
          li.classList.add('is-selected');
          li.setAttribute('aria-selected', 'true');
        } else {
          li.setAttribute('aria-selected', 'false');
        }
        li.addEventListener('click', function () {
          selectBrand(brand.v, displayLabel);
          closePanel();
        });
        list.appendChild(li);
      });
    }

    /* ---- Select a brand ---- */

    function selectBrand(value, label) {
      brandValueInput.value = value;
      brandDisplay.textContent = label;
      brandDisplay.classList.add('is-selected');
      brandOptions.forEach(function (opt) {
        var active = opt.dataset.value === value;
        opt.classList.toggle('is-selected', active);
        opt.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    brandOptions.forEach(function (opt) {
      opt.addEventListener('click', function () {
        selectBrand(opt.dataset.value, opt.dataset.label);
        closePanel();
      });
    });

    /* ---- Search button ---- */

    searchBtn.addEventListener('click', doSearch);
    modelEl.addEventListener('keydown', function (e) { if (e.key === 'Enter') doSearch(); });

    function doSearch() {
      var brand = brandValueInput.value.trim();
      var model = modelEl.value.trim();

      if (!model) {
        modelEl.focus();
        modelEl.classList.add('pf-model--error');
        setTimeout(function () { modelEl.classList.remove('pf-model--error'); }, 2000);
        return;
      }

      var terms = [model];
      if (brand) terms.push(brand);

      window.location.href = '/search?type=product&q=' + encodeURIComponent(terms.join(' '));
    }
  }

  function init() {
    document.querySelectorAll('[data-part-finder-id]').forEach(function (el) {
      PartFinder(el.dataset.partFinderId);
    });
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();

})();
